import { render, staticRenderFns } from "./A2pDetail.vue?vue&type=template&id=61aeb126&scoped=true"
import script from "./A2pDetail.vue?vue&type=script&lang=js"
export * from "./A2pDetail.vue?vue&type=script&lang=js"
import style0 from "./A2pDetail.vue?vue&type=style&index=0&id=61aeb126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aeb126",
  null
  
)

export default component.exports